export function widgetIsCompatible(widget: any): boolean {
    if (widget?.jsonConfig?.verticalEnabled === true) return true

    switch (String(widget?.type).toLocaleLowerCase()) {
        case 'wbs':
            return true
        case 'bha':
            return true
        default:
            return false
    }
}
